import api from '@/services/api';

/**
 * Creates a better-auth session for a kiosk running on an OTP-disabled booth.
 *
 * The kiosk flow skips /otp entirely in DISABLED mode, so no session cookie is
 * ever set by the OTP verification — without this call every authenticated
 * endpoint (jobs, applications, dashboard) returns 401.
 * The backend only accepts it for booths explicitly configured with OTP
 * disabled.
 */
export async function createKioskSession(machineUid: string, phoneNumber: string): Promise<void> {
  await api.post('/kiosk-auth/session', { machineUid, phoneNumber }, { showErrorToast: false });
}
